<template>
  <div>
    <div>
      <page-header heading="Featured Courses"
        desc="Click on the tabs below to select your respective program."></page-header>
    </div>
    <section class="popular-exams-section online-course-details exams-grid" id="popularExamsSection">
      <!-- :class="{ 'sticky-tab': isHeaderSticky } -->
      <div id="header" class="tabs-slider featured-program-categories" v-if="programCategories.length">
        <div ref="header" :class="{ 'sticky-tab': isHeaderSticky }"
          class="featured-program-wrap d-flex justify-content-center">
          <div class="featured-program-categories-inside">
            <!-- <SsrCarousel :slides-per-page="null" :responsive="[{ maxWidth: 425, slidesPerPage: 2 }]"> -->
            <div v-for="(category, index) in featuredProgramCategories" :key="index" @click="goto(category)"
              class="exam-tabs-head upperHeadings" :class="{
                featuredProgramMainHead: selectedCategory == category.ProgramCategory.ProgramCategoryId,
              }">
              {{ category.ProgramCategory.Category }}
            </div>
            <!-- </SsrCarousel> -->
          </div>
        </div>
        <div v-if="getCategoryGroups && getCategoryGroups.length > 0">
          <popularExams :selectedCategoryId="selectedCategory" :groups="getCategoryGroups" />
        </div>
        <div v-else class="text-center my-5">No program found.</div>
      </div>
      <div v-else class="text-center my-5">No program found.</div>
    </section>
    <Footer />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { programCategories as programCategoriesStoreKeys } from "../store/keys";
import SsrCarousel from "vue-ssr-carousel";
import popularExams from "../views/course/exam/popularExams";
import pageHeader from "./pageHeader";
import Footer from "../layout/landing/appFooter";
export default {
  components: {
    SsrCarousel,
    popularExams,
    pageHeader,
    Footer,
  },
  metaInfo: {
    title: "Featured Courses | KIPS VIRTUAL",
    titleTemplate: "",
    meta: [
      {
        name: "description",
        content: "Browse featured courses on KIPS Virtual and discover exam preparation programs, live classes, and digital learning paths.",
      },
      {
        name: "keywords",
        content: "KIPS Virtual, featured courses, exam preparation, online courses, study programs, digital learning",
      },
      {
        property: "og:title",
        content: "Featured Courses | KIPS VIRTUAL",
      },
      {
        property: "og:description",
        content: "Browse featured courses on KIPS Virtual and discover exam preparation programs, live classes, and digital learning paths.",
      },
      {
        property: "og:type",
        content: "website",
      },
    ],
    link: [
      {
        rel: "canonical",
        href: "https://kipsvirtual.com/featuredCourses",
      },
    ],
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
  data() {
    return {
      selectedCategory: null,
      isHeaderSticky: false,
    };
  },
  mounted() {
    this.getProgramCategories();
    window.addEventListener("scroll", () => {
      this.scrollY = Math.round(window.scrollY);
      if (this.$refs.header) {
        this.headerTop = document.getElementById("popularExamsSection").offsetTop;
        if (this.scrollY > this.headerTop + 100) {
          this.isHeaderSticky = true;
          document.body.classList.add("exam-body");
        } else {
          this.isHeaderSticky = false;
          document.body.classList.remove("exam-body");
        }
      }
    });
  },
  computed: {
    ...mapGetters(programCategoriesStoreKeys.namespace, programCategoriesStoreKeys.getters),
    getCategoryGroups() {
      const filteredCategories = this.programCategories.filter((category) => {
        return category.ProgramCategory.ProgramCategoryId == this.selectedCategory && category.HasFeaturedSoS;
      });
      const uniqueGroups = [
        ...new Set(
          filteredCategories
            .filter((obj) => {
              if (obj.Group) {
                return obj;
              }
            })
            .map((obj) => obj.Group.CourseGroupId)
        ),
      ]
        .map((id) => {
          return filteredCategories.find((obj) => obj.Group && obj.Group.CourseGroupId === id);
        })
        .map((category) => {
          return category.Group;
        });
      let filter = [{ CourseGroupDisplayName: "All", CourseGroupId: undefined }];
      if (uniqueGroups.length) {
        return uniqueGroups.length === 1 ? uniqueGroups : [...filter, ...uniqueGroups];
      } else return [];
    },
  },
  methods: {
    ...mapActions(programCategoriesStoreKeys.namespace, programCategoriesStoreKeys.actions),
    getProgramCategories() {
      this.get_ProgramCategories({
        config: {
          loader: {
            show: true,
            id: "boardLoader",
          },
        },
      }).then(() => {
        if (this.featuredProgramCategories && this.featuredProgramCategories.length > 0) {
          this.selectedCategory = this.featuredProgramCategories[0].ProgramCategory.ProgramCategoryId;
        }
        // this.selectedCategory = 1;
      });
    },
    goto(category) {
      this.selectedCategory = category.ProgramCategory.ProgramCategoryId;
    },
  },
};
</script>

<style></style>
